import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';
import deepmerge from 'deepmerge';

import useNotification from '../../../core/hooks/use_notification';
import { getPodsNotificationData, getTheftRegistriesForStoreNotificationData } from '../../../core/utils/notification_utils';
import { getDefaultTheftRegistriesPaginationQueryValues } from '../../../core/utils/api_utils';
import PaginationControls from '../../common/pagination_controls';
import TheftRegistriesList from './list';
import TheftRegistriesFilters from './filters';
import { getTheftRegistriesForStoreAction, getTheftRegistriesForStoreState } from '../../../features/order/get_theft_registries_for_store';
import { getAllPodsAction, getAllPodsState } from '../../../features/pod/get_all_pods';
import PageHeader from '../../common/page_header';

const initialQueryParams = {
    ...getDefaultTheftRegistriesPaginationQueryValues,
    status: 'IN_REALIZATION',
    invoiceNumber: ''
};

const TheftRegistriesPage = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const location = useLocation();

    const getTheftRegistriesForStore = useSelector(getTheftRegistriesForStoreState);
    const getAllPods = useSelector(getAllPodsState);

    const [queryParams, setQueryParams] = useState(location?.state?.queryParams || initialQueryParams);

    const refreshList = useCallback(() => {
        dispatch(getTheftRegistriesForStoreAction(queryParams))
            .then(response => showErrorMessage(getTheftRegistriesForStoreNotificationData(response)));
        dispatch(getAllPodsAction())
            .then(response => showErrorMessage(getPodsNotificationData(response)));
    }, [dispatch, queryParams, showErrorMessage]);

    useEffect(() => {
        refreshList();
    }, [refreshList]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader title="Kradzieże"/>

            <TheftRegistriesFilters
                queryParams={ queryParams }
                setQueryParams={ setQueryParams }
            />

            {
                (getTheftRegistriesForStore?.loading || getAllPods?.loading) &&
                <Box sx={ { width: '100%' } }>
                    <LinearProgress/>
                </Box>
            }

            {
                (getTheftRegistriesForStore?.data?.content && getAllPods?.data) &&
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <TheftRegistriesList queryParams={ queryParams } refreshList={ refreshList }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getTheftRegistriesForStore?.data?.pageable?.pageNumber }
                            totalPages={ getTheftRegistriesForStore?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            }
        </Box>
    );
};

export default TheftRegistriesPage;